import React from 'react'
import { Form } from '@ztechapps/webui.form'
import { useContext } from './Context'
import { useSubmitRegister } from './useSubmitRegister'
import { Stack } from 'react-bootstrap'

export const Layout = () => {
  const { components, ...context } = useContext()
  const { initialValues, validate } = context
  const submitRegister = useSubmitRegister()

  return (
    <Form initialValues={initialValues} validate={validate} onSubmit={submitRegister}>
      <Stack gap={2}>
        <components.errorDisplay />
        <components.form />
        <components.button />
      </Stack>
    </Form>
  )
}
